<app-pills-overflow [items]="pillItems()" [maxRows]="3" [pillHeight]="24" [gapSize]="6">
  <ng-template #pillTemplate let-item let-clickable="clickable">
    @let decoration = decorationOf(item);
    @if (clickable) {
      <button
        #pill
        type="button"
        class="hover:border-accent-border hover:bg-accent-interactive bg-elevated border-default inline-flex w-full cursor-pointer items-center gap-1 overflow-hidden rounded-full border px-2.5 py-0.5 transition-all"
        (mouseenter)="onPillHover(item)"
        (mouseleave)="onPillHoverEnd()"
        (click)="$event.stopPropagation(); onPillClick(item, $event)">
        <ng-container *ngTemplateOutlet="pillBody; context: { $implicit: item }" />
      </button>
      @if (decoration?.tooltip; as tooltip) {
        @let html = tooltipHtml(tooltip);
        <app-tooltip
          [target]="pill"
          [position]="'top'"
          [maxWidth]="420"
          [title]="html.title"
          [content]="html.content" />
      }
    } @else {
      <div
        class="bg-elevated border-default inline-flex w-full items-center gap-1 overflow-hidden rounded-full border px-2.5 py-0.5 transition-all">
        <ng-container *ngTemplateOutlet="pillBody; context: { $implicit: item }" />
      </div>
    }
  </ng-template>
</app-pills-overflow>

<ng-template #pillBody let-item>
  @for (icon of decorationOf(item)?.icons ?? []; track $index) {
    <i
      aria-hidden="true"
      [class]="icon.iconClass"
      [class.text-accent-main]="icon.tone === 'accent'"
      [class.text-text-tertiary]="icon.tone === 'muted'"
      class="text-xs"></i>
  }
  <p class="text-text-primary text-2xs truncate font-mono font-medium">
    {{ item.label ?? item.data }}
  </p>
</ng-template>
